import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthenticationStore, SignInComponent } from '@pflegix/authentication';
import { I18NextAdapterPipe, I18nService } from '@pflegix/i18n';
import { ButtonComponent } from '@pflegix/ui';

@Component({
  selector: 'pfx-login-view',
  imports: [SignInComponent, RouterLink, ButtonComponent, I18NextAdapterPipe],
  templateUrl: './login-view.component.html',
})
export class LoginViewComponent {
  private readonly i18n = inject(I18nService);

  protected authenticationStore = inject(AuthenticationStore);

  constructor() {
    this.i18n.addTranslations({
      namespace: 'login-view',
      de: { become_partner: 'Kooperationspartner werden' },
      en: { become_partner: 'Become a partner' },
    });
  }
}
